import { Injectable } from '@angular/core';
import { TransactionalService } from '../transactional.service';
import { ICreateContactUsSubmission } from '../../../models/dtos/create/create-contact-us-submission.interface';
import { Observable } from 'rxjs';
import { IResponse } from '../../../models/dtos/response.interface';

@Injectable({
  providedIn: 'root'
})
export class ContactUsSubmissionService {

  constructor(private _transactionService: TransactionalService) { }

  public create(model: ICreateContactUsSubmission): Observable<IResponse<boolean>> {
    return this._transactionService.add<ICreateContactUsSubmission, IResponse<boolean>>(model, 'create-contact-us-submission');
  }
}
